import lottie from 'lottie-web';
import animationData from '@/assets/data/bg-image-animation.json';


const wave = (bg, type) => {
  const name = bg.getAttribute('js-lottieref');
  const wave = lottie.loadAnimation({
    container: bg,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationData[type],
    name,
    rendererSettings: {
      clearCanvas: true,
      preserveAspectRatio: 'none',
    },
  });

  wave.onComplete = () => {
    if (type !== 'speakers') {
      bg.removeAttribute('js-target');
      wave.destroy();
    }
  };

  return wave;
};

export default wave;
